import { jsx as _jsx } from "react/jsx-runtime";
import { Navigation as UINavigation } from "@bluframe/mightychroma-mightytool-ui";
const Navigation = ({ firstName, isAdmin, isEditor, isExpanded, isSocials, onToggleIsExpanded }) => (_jsx(UINavigation, { isAdmin: isAdmin, isEditor: isEditor, isExpanded: isExpanded, isSocials: isSocials, name: firstName, onToggleIsExpanded: onToggleIsExpanded }));
export default Navigation;
